import dashboard from '@/navigation/vertical/Ptc/dashboard';
import relatoriosRouter from './relatorios/relatorios.router';
import cadastrosRouter from './cadastros/cadastro.router';
import clienteDkpRouter from './cliente-dkp/cliente-dkp.router';
import sistemaRouter from './sistema/sistema.router';
import publicasRouter from './publicas';
import operacao from './operacao/operacoes';

export default [
  ...publicasRouter,
  ...clienteDkpRouter,
  ...sistemaRouter,
  ...operacao,
  ...relatoriosRouter,
  ...cadastrosRouter,
  ...dashboard,
];
